import React from "react";
import { IStyleFunctionOrObject } from "@fluentui/react";
import { Dropdown, IDropdownStyleProps, IDropdownStyles } from "@fluentui/react/lib/Dropdown";
import { classNames } from "maven-lib/dist/utils/misc";

export interface CrDropdownItemProps {
  key: string | number | null;
  text: string;
  disabled?: boolean;
}

export interface CrDropdownProps {
  className?: string;
  calloutClassName?: string;
  panelClassName?: string;
  placeholder?: string;
  required?: boolean;
  label?: string;
  defaultKey?: string | number;
  defaultSelectedKeys?: string[];
  selectedKey?: string | number | null;
  selectedKeys?: string[] | null;
  items: Array<CrDropdownItemProps>;
  onValueChange?: (val: string | number | null) => void;
  onFocus?: () => void;
  unselectable?: boolean;
  disabled?: boolean;
  multiSelect?: boolean;
  styles?: IStyleFunctionOrObject<IDropdownStyleProps, IDropdownStyles>;
  /** false 일 경우 새로운 레이어에 dropdown을 그립니다. true 일 경우 새 레이어에 그리지 않습니다 */
  doNotLayer?: boolean;
}

export function CrDropdown(props: CrDropdownProps) {
  const {
    className,
    calloutClassName,
    panelClassName,
    placeholder,
    label,
    required,
    defaultKey,
    defaultSelectedKeys,
    selectedKey,
    selectedKeys,
    items,
    onValueChange,
    onFocus,
    disabled,
    styles,
    multiSelect,
    unselectable,
    doNotLayer,
  } = props;

  return (
    <>
      <Dropdown
        defaultSelectedKey={defaultKey}
        defaultSelectedKeys={defaultSelectedKeys}
        className={classNames("cr-dropdown", className, unselectable && "--unselectable")}
        calloutProps={{
          className: classNames("cr-dropdown-callout", calloutClassName, unselectable && "--unselectable"),
          gapSpace: 1,
          doNotLayer,
        }}
        panelProps={{ className: classNames("cr-dropdown-panel", panelClassName, unselectable && "--unselectable") }}
        placeholder={placeholder}
        required={required}
        label={label}
        options={(unselectable ? [{ key: null, text: placeholder || "Choose .." }] : []).concat(items)}
        onChange={(_, val) => onValueChange && onValueChange(val?.key || typeof val?.key === "number" ? val.key : "")}
        onFocus={onFocus}
        disabled={disabled}
        multiSelect={!!multiSelect}
        styles={styles}
        selectedKey={selectedKey}
        selectedKeys={selectedKeys}
      ></Dropdown>
    </>
  );
}

CrDropdown.defaultProps = {
  selectFirstValueAutomatically: true,
};
